let API_PATH = ''
let TRA_GET = ''
let TRA_GET_MANAGER = ''
if (process.env.NODE_ENV === 'development') {
  TRA_GET = 'http://uat.sjysz.com:5840/exam/socket/auth'
  TRA_GET_MANAGER = 'http://uat.sjysz.com:5840/exam/socket/manager'
  API_PATH = 'http://localhost:5840/api'
  // API_PATH = 'http://test.api.edu.sjysz.com/api'
} else if (process.env.NODE_ENV === 'production') {
  API_PATH = 'http://api.edu.sjysz.com:80/api'
  TRA_GET = 'http://uat.sjysz.com:5840/exam/socket/auth'
  TRA_GET_MANAGER = 'http://uat.sjysz.com:5840/exam/socket/manager'
}
export {
  API_PATH,
  TRA_GET,
  TRA_GET_MANAGER
}



// WEBPACK FOOTER //
// ./src/config/env.js